// Shift time to display 2 columns the same date:
// the 1st column so that we'll have 2 columns per day instead of just one
import { TAB_OVERVIEW } from '../views/accounts/overview';
import {DASHBOARDROUTE} from '../views/dashboard/dashboard';
import { TOP_NUMBER } from '../components/tables/accounts/accountsView.directive';
export const BAR_TIME_SHIFT = 16000000;
export const PIE_MAPPING = { bank : "app.accountsByBank", currency : "app.accountsByCurrency" };

export class FlotService {

    constructor($document, userService, $state) {
        this.topNumber = 4;
        this.document = $document;
        this.filterFormatter = userService.filterFormatter;
        this.fsMainDependencies = userService.fsMainDependencies;
        this.$state = $state;
        this.legendLabel = function labelFormatter(label, series) {
            return '<div>' + label + ' '+ series.percent.toFixed(1) + '%</div>';
        };
    }

    chartHover(event, pos, item) {
        $("#flot_chart_tooltip").remove();

        if(item && item.series.label && item.series.data) {
            this.showChartTooltip(pos.pageX, pos.pageY,
                parseFloat(item.series.data[0][1]),' ' + item.series.label, item.series.fractionDigits );
        }
    }

    historyChartHover(event, pos, item) {
        $("#flot_chart_tooltip").remove();
         if(item && item.datapoint && item.datapoint[0]) {
             const formattedDate = this.filterFormatter('fsDateNoLocal')(item.datapoint[0] + BAR_TIME_SHIFT);
             const label = item.series.label ? item.series.label : '';
             this.showChartTooltip(pos.pageX, pos.pageY,
                parseFloat(item.datapoint[1]),' ' + label + ' '+ formattedDate, item.series.fractionDigits);
        }
    }

    showChartTooltip(x, y, amount, label, fractionDigits) {
        const flot_chart_tooltip = angular.element(
            '<div id="flot_chart_tooltip">' + this.filterFormatter('fsNumber')(amount, fractionDigits) +
            '<br/><i>' + label + '</icon></div>');
        flot_chart_tooltip.css({
            position: 'absolute',
            top: (y + 20) + 'px',
            left: (x - 90) + 'px',
            border: 'solid 1px $gray-lighter',
            'border-radius': '2px',
            background: 'linear-gradient(white, #f7f7f9)',
            color: '#525252',
            'font-family': '"Helvetica Neue", Helvetica, Arial, sans-serif',
            padding: '3px',
            'z-index': '2',
            '-webkit-box-shadow': '2px 2px 1px #C7C7C7',
            '-moz-box-shadow': '2px 2px 1px #C7C7C7',
            'box-shadow': '2px 2px 1px #C7C7C7'
        });
        const body = this.document.find('body').eq(0);
        body.append(flot_chart_tooltip);
    }

    constructList(dataList, targetList, userService) {

        if (dataList.length > TOP_NUMBER) {
            const otherAmount = dataList.slice(this.topNumber+1, dataList.length).reduce((o, a)=> o + a.consolidatedBalance.amount, 0);
            const otherAccNum = dataList.slice(this.topNumber+1, dataList.length).reduce((o, a)=> o + a.numberOfAccounts, 0);

            targetList.push({
                name: this.fsMainDependencies.$translate.instant('OTHER'),
                code: 'OTHER',
                consolidatedBalance: {
                    amount: otherAmount,
                    fractionDigits: dataList[0].consolidatedBalance.fractionDigits
                },
                numberOfAccounts: otherAccNum
            });
        }
        this.formatAmounts(userService, targetList);
    }

    formatAmounts(userService, targetList) {
        userService.promise.then(() => {
            targetList.forEach((acc) => {
                acc.formattedBalance = this.filterFormatter('fsNumber')(acc.consolidatedBalance.amount, acc.consolidatedBalance.fractionDigits);
            });
        });
    }
    constructChart(origData, dataList, userService) {
        this.constructList(origData, dataList, userService);

        // all are negative or zero no piechart display
        if(dataList.filter((d) => d.consolidatedBalance.amount <= 0).length == dataList.length) {
            return [];
        }
        // there's some positive values
        return dataList.filter((d) => d.consolidatedBalance.amount >= 0).map((d) => {
            // there's an empty name
            let label = d.code ? d.code : ' ';
            if(d.name && !d.code){
                label = d.name;
            }
            if(label) {
                label = label.substring(0, 13);
            } 

            return { label: label,  completeName: d,
                data: d.consolidatedBalance.amount, fractionDigits: d.consolidatedBalance.fractionDigits };
        });
    }

    // broadcasts filtering to accountsFilter.directive.js
    pieClicked(event, pos, item, itemKind) {
        if (item.series.label === "Other") {
            this.fsMainDependencies.toast.warning(this.fsMainDependencies.$translate.instant("NOT_FOUND_MESSAGE"));
        } else {
            if (this.$state.params.tabName === TAB_OVERVIEW ||
                this.$state.current.name === DASHBOARDROUTE) {
                $("#flot_chart_tooltip").remove();

                const moveToHash = () => this.$state.go(PIE_MAPPING[itemKind], { 'anchorName' : item.series.completeName });
                moveToHash();
            } else {
                this.fsMainDependencies.$rootScope.$broadcast('expandGroupData', item.series.completeName );
            }
        }
    }
}
